import { Box, Button, TextField } from '@material-ui/core';

import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';

import TodayIcon from '@material-ui/icons/Today';

import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';

type Props = {
  yearRound: 'floor' | 'ceil';
  onChange: (item: string) => void;
  onError: (error: string) => void;
  label: string | ReactNode;
  id: string;
  value: string;
  hasError: boolean;
  disabled?: boolean;
};
// TODO: treba spracovat externu value este - na inicializaciu a resetovanie fieldu
export default function CustomDateField({
  yearRound,
  onChange,
  onError,
  label,
  id,
  value,
  hasError,
  disabled,
}: Props) {
  const [dateString, setDateString] = useState(''); // TODO: value?
  const [date, setDate] = useState<Date>();

  useEffect(() => {
    if (!value) {
      setDateString(value ?? '');
    }
  }, [value]);

  const handleParseDate = useCallback(
    (value: string) => {
      setDateString(value);

      const arr = value.split('.');
      if (arr.length !== 3 && arr.length !== 1) {
        onError('Nesprávný formát dátumu');
        return;
      }

      const maxYear = new Date().getFullYear();

      if (arr.length === 3) {
        const day = parseInt(arr[0]);
        const month = parseInt(arr[1]);
        const year = parseInt(arr[2]);

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
          onChange('');
          return;
        }

        if (day < 1 || day > 31) {
          onChange('');
          return;
        }
        if (month < 1 || month > 12) {
          onChange('');
          return;
        }
        if (year < 1000 || year > maxYear) {
          onChange('');
          return;
        }
        const date = new Date(`${year}-${month}-${day}`);
        setDate(date);
        onChange(date.toISOString().substring(0, 10));

        return;
      }
      try {
        if (arr[0] === '') {
          onChange('');
          return;
        }
        const year = parseInt(arr[0]);
        if (isNaN(year) || year < 1000 || year > maxYear) {
          //onChange('');
          //setDate(undefined);
          onError('Dátum mimo povolený rozsah.');
          return;
        }
        const dateString =
          yearRound === 'floor' ? `${year}-01-01` : `${year}-12-31`;
        onChange(dateString);
        setDate(new Date(dateString));
      } catch (error) {
        onError('Nesprávný formát dátumu');
      }
    },
    [onChange, yearRound, onError]
  );

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <TextField
        disabled={disabled}
        style={{ width: '100%' }}
        label={label}
        id={id}
        name={id}
        placeholder="RRRR nebo DD.MM.RRRR"
        onKeyPress={(e) => {
          const re = /[0-9.]+/g;
          if (!re.test(e.key)) {
            e.preventDefault();
          }
        }}
        //maxLength={10}
        variant="outlined"
        error={hasError}
        value={dateString}
        onChange={(e) => {
          if (e.target.value.replaceAll(' ', '').length > 10) {
            return;
          }

          handleParseDate(e.target.value);
        }}
      />
      <DatePicker
        tabIndex={-1}
        disabled={disabled}
        selected={date}
        onChange={(date) => {
          if (date) {
            onChange(format(date as Date, 'yyyy-MM-dd'));
            setDate(date as Date);
            setDateString(format(date as Date, 'dd.MM.yyyy'));
          }
        }}
        showYearDropdown
        strictParsing
        customInput={
          <Button style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TodayIcon fontSize="default" />
          </Button>
        }
      />
    </Box>
  );
}
